export default __webpack_public_path__ + "static/Entenda0056-7233b50a0e9e74ad8f22c7110383a837.jpg";